import React, { ReactElement } from 'react';
import { Loader } from '../Loader/Loader';

/**
 * @component to render Loader in the cell if its value is empty
 */

export const LoadableCell = (
  { children, isLoading }: { children: ReactElement; isLoading?: boolean }
): ReactElement => {
  const loading = isLoading || !children;
  return loading ? <Loader /> : children;
};

export const renderLoadableCell = (value: ReactElement): ReactElement => <LoadableCell>{value}</LoadableCell>;
